import { clear, get, set } from "./local-storage";

const USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY = "selected_location";
export const setOnLocalStorage = (location) => set(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
export const getFromLocalStorage = () => get(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY);